// extracted by mini-css-extract-plugin
export default {"errorParagraph":"validateStyles_errorParagraph__HF1Vo","notValid":"validateStyles_notValid__8rldV"};